<template>
  <div class="home_icon" ref="home_icon">
    <div class="icon">
      <svg-icon :icon-class="iconSrc"></svg-icon>
    </div>
    <div class="text">{{iconText}}</div>
  </div>
</template>

<script>
export default {
  props: {
    iconSrc: {
      type:String,
      default:'real_estate'
    },
    iconText:{
      type:String,
      default:'婚姻家庭'
    } ,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.home_icon {
  width: 98px;
  cursor: pointer;

  &:hover {
    .icon {
      background-color: #0465ea;
      color: #ffffff;
    }
    .text {
      color:#0465ea;
    }
  }
  .icon {
    width: 98px;
    height: 98px;
    margin: 0 auto;
    line-height: 98px;
    font-size: 44px;
    text-align: center;
    border-radius: 50%;
    background-color: #f8f8f8;
    color: #666666;
  }
  .text {
    margin-top: 19px;
    font-size: 18px;
    color: #333333;
  }
}
</style>